"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var PRIVATE_MESSAGE_TYPES = ['privmsg', 'action'];
var _default = exports.default = {
  props: ['network', 'activeBuffer'],
  data: function data() {
    return {
      requests: []
    };
  },
  computed: {
    visibleRequests: function visibleRequests() {
      var _context,
        _context2,
        _context3,
        _this = this;
      if (!this.network) {
        return [];
      }
      return (0, _slice.default)(_context = (0, _filter.default)(_context2 = (0, _filter.default)(_context3 = this.requests).call(_context3, function (request) {
        return request.networkid === _this.network.id;
      })).call(_context2, function (request) {
        return !_this.activeBuffer || request.buffer.id !== _this.activeBuffer.id;
      })).call(_context, -3);
    }
  },
  watch: {
    activeBuffer: function activeBuffer(buffer) {
      if (buffer && buffer.isQuery && buffer.isQuery()) {
        this.dismissRequest(this.requestKey(buffer));
      }
    }
  },
  created: function created() {
    var _this2 = this;
    this.listen(this.$state, 'message.new', this.onNewMessage);
    this.listen(this.$state, 'buffer.close', function (event) {
      if (event && event.buffer) {
        _this2.dismissRequest(_this2.requestKey(event.buffer));
      }
    });
  },
  methods: {
    onNewMessage: function onNewMessage(event) {
      var _context4;
      if (!event || !event.buffer || !event.message) {
        return;
      }
      var buffer = event.buffer,
        message = event.message;
      var network = buffer.getNetwork && buffer.getNetwork();
      if (!network || !buffer.isQuery || !buffer.isQuery()) {
        return;
      }
      if (this.activeBuffer && this.activeBuffer.id === buffer.id) {
        return;
      }
      if (PRIVATE_MESSAGE_TYPES.indexOf(message.type) === -1) {
        return;
      }
      if (message.ignore) {
        return;
      }
      if (!message.nick || message.nick === '*' || message.nick === network.nick) {
        return;
      }
      var key = this.requestKey(buffer);
      var current = (0, _find.default)(_context4 = this.requests).call(_context4, function (request) {
        return request.key === key;
      });
      if (current) {
        current.count += 1;
        current.time = Date.now();
        current.nick = message.nick;
        return;
      }
      this.requests.push({
        key: key,
        buffer: buffer,
        networkid: buffer.networkid,
        nick: message.nick,
        initial: message.nick.charAt(0).toUpperCase(),
        count: 1,
        time: Date.now()
      });
      if (this.requests.length > 8) {
        this.requests.shift();
      }
    },
    requestKey: function requestKey(buffer) {
      return buffer.networkid + ':' + buffer.name.toLowerCase();
    },
    dismissRequest: function dismissRequest(key) {
      var _context5;
      this.requests = (0, _filter.default)(_context5 = this.requests).call(_context5, function (request) {
        return request.key !== key;
      });
    },
    acceptRequest: function acceptRequest(request) {
      this.$state.setActiveBuffer(request.networkid, request.buffer.name);
      this.dismissRequest(request.key);
    },
    rejectRequest: function rejectRequest(request) {
      var buffer = this.$state.getBufferByName(request.networkid, request.buffer.name);
      if (buffer && (!this.activeBuffer || this.activeBuffer.id !== buffer.id)) {
        this.$state.removeBuffer(buffer);
      }
      this.dismissRequest(request.key);
    },
    ignoreRequest: function ignoreRequest(request) {
      var user = this.$state.getUser(request.networkid, request.nick);
      if (!user) {
        user = this.$state.addUser(request.networkid, {
          nick: request.nick
        });
      }
      if (user) {
        user.ignore = true;
      }
      this.rejectRequest(request);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["PrivateMessageNotice"]
window._kiwi_exports.components.PrivateMessageNotice = exports.default ? exports.default : exports;
